import { Component, OnInit } from '@angular/core';
import { AlloyService } from '../shared/alloy/alloy.service';
import { LoginService } from '../shared/user-login/login.service';
import { FormGroup, FormControl, Validators  } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';

@Component({
    selector: 'app-alloy',
    templateUrl: './alloy.component.html',
    styleUrls: ['./alloy.component.scss'],
    standalone: false
})

export class AlloyComponent implements OnInit {
  alloys = []
  // grades = ['420/10', '500/7', 'SiBoDur500', 'CGI-FeSiLa', 'SiMi406','---']
  gIron = ['Grey Iron','Ductile Iron']
  ironType = ['Base Iron','Final Iron']
 
  alloy
  role: string
  reset: boolean = false
  serverErrorMessages: string
  loading: boolean = true
  editGELWEL: boolean = false
  copiedAlloy
  initialValues
  constructor(private alloyService: AlloyService, private loginService: LoginService, private router : Router) { }
  alloyForm = new FormGroup ({
    name: new FormControl('-- Not provided --'),
    iron1: new FormControl('Grey Iron'),
    iron2: new FormControl('Base Iron'),
    greyIron: new FormGroup({
      baseIron: new FormControl(false),
      finalIron: new FormControl(false),
    }),
    ductileIron: new FormGroup({
      baseIron: new FormControl(false),
      finalIron: new FormControl(false),
    }),
    // CGIron: new FormGroup({
    //   baseIron: new FormControl(false),
    //   finalIron: new FormControl(false),
    // }),
    grade: new FormControl('',[Validators.required]),
    chemistry: new FormGroup({
      C: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Si: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Mn: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      P: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      S: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Cr: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Cu: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Mg: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Ni: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Mo: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      V: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Fe: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Sn: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Nb: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      B: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      W: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Zn: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Pb: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Ti: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),
      Sr: new FormGroup({
        minmax:new FormGroup({
          min: new FormControl(0),
          max: new FormControl(0),
        }),
        mean: new FormControl(0)
      }),

    }),
    calculatedValues: new FormGroup({
      GRADE: new FormControl('---'),
      GEL: new FormControl(''),
      WEL: new FormControl(''),
      TL_REF: new FormControl(''),
    })
  });

  stdAlloyList = [];
  dropdownList = [];
  dropdownSettings: IDropdownSettings;

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
          // this.getStandardAlloys();
         //console.log('User', this.role);
          this.alloyService.currentAlloy.subscribe(alloy=>{
            this.copiedAlloy = alloy;
           //console.log(this.copiedAlloy)
            if(Object.keys(this.copiedAlloy).length !== 0){
              this.fillForm()
            }
          })
          this.loading = false;
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )
    }else{
      this.loading = false;
    }

    // this.stdAlloyList = this.alloys.map( x => { return {item_id: x._id, item_text: x.name }});

    this.onChanges();
  }

  onSubmit(){
    if (this.alloyForm.get('iron1').value=="Grey Iron") {
      if (this.alloyForm.get('iron2').value=="Base Iron") {
        this.alloyForm.get('greyIron').get('baseIron').setValue(true);
      }
      else if (this.alloyForm.get('iron2').value=="Final Iron") {
        this.alloyForm.get('greyIron').get('finalIron').setValue(true);
      }
    }
    else if (this.alloyForm.get('iron1').value=="Ductile Iron") {
      if (this.alloyForm.get('iron2').value=="Base Iron") {
        this.alloyForm.get('ductileIron').get('baseIron').setValue(true);
      }
      else if (this.alloyForm.get('iron2').value=="Final Iron") {
        this.alloyForm.get('ductileIron').get('finalIron').setValue(true);
      }
    }
    // else if (this.alloyForm.get('iron1').value=="CG Iron") {
    //   if (this.alloyForm.get('iron2').value=="Base Iron") {
    //     this.alloyForm.get('CGIron').get('baseIron').setValue(true);
    //   }
    //   else if (this.alloyForm.get('iron2').value=="Final Iron") {
    //     this.alloyForm.get('CGIron').get('finalIron').setValue(true);
    //   }
    // }
   //console.log('came here', this.alloyForm.value)
    this.alloyService.saveAlloy({alloyData: this.alloyForm.value}).subscribe(
      res=>{
       //console.log('successfully saved', res)
        alert("Alloy created Successfully!!");
        this.router.navigateByUrl('/home');

      },
      err=>{
       console.log('error saving alloy', err)
      }
    )
    this.alloyForm.reset();
  }

  fillForm() {
    //SET VALUES
    console.log(this.copiedAlloy)
    if (this.copiedAlloy.greyIron.baseIron || this.copiedAlloy.greyIron.finalIron) this.alloyForm.get('iron1').setValue("Grey Iron");
    else this.alloyForm.get('iron1').setValue("Ductile Iron");
    if (this.copiedAlloy.ductileIron.baseIron || this.copiedAlloy.greyIron.baseIron) this.alloyForm.get('iron2').setValue("Base Iron");
    else this.alloyForm.get('iron2').setValue("Final Iron");
    this.alloyForm.get('name').setValue(this.copiedAlloy.name)
    this.alloyForm.get('grade').setValue(this.copiedAlloy.grade)

    this.alloyForm.get('chemistry').get('C').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.C.minmax.min)
    this.alloyForm.get('chemistry').get('C').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.C.minmax.max)
    
    this.alloyForm.get('chemistry').get('Si').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Si.minmax.min)
    this.alloyForm.get('chemistry').get('Si').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Si.minmax.max)
    
    this.alloyForm.get('chemistry').get('Mn').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Mn.minmax.min)
    this.alloyForm.get('chemistry').get('Mn').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Mn.minmax.max)
    
    this.alloyForm.get('chemistry').get('P').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.P.minmax.min)
    this.alloyForm.get('chemistry').get('P').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.P.minmax.max)
    
    this.alloyForm.get('chemistry').get('S').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.S.minmax.min)
    this.alloyForm.get('chemistry').get('S').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.S.minmax.max)

    this.alloyForm.get('chemistry').get('Fe').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Fe.minmax.min)
    this.alloyForm.get('chemistry').get('Fe').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Fe.minmax.max)

    this.alloyForm.get('chemistry').get('Cr').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Cr.minmax.min)
    this.alloyForm.get('chemistry').get('Cr').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Cr.minmax.max)
    
    this.alloyForm.get('chemistry').get('Cu').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Cu.minmax.min)
    this.alloyForm.get('chemistry').get('Cu').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Cu.minmax.max)
    
    this.alloyForm.get('chemistry').get('Mg').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Mg.minmax.min)
    this.alloyForm.get('chemistry').get('Mg').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Mg.minmax.max)
    
    this.alloyForm.get('chemistry').get('Ni').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Ni.minmax.min)
    this.alloyForm.get('chemistry').get('Ni').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Ni.minmax.max)
    
    this.alloyForm.get('chemistry').get('Mo').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Mo.minmax.min)
    this.alloyForm.get('chemistry').get('Mo').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Mo.minmax.max)
    
    this.alloyForm.get('chemistry').get('V').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.V.minmax.min)
    this.alloyForm.get('chemistry').get('V').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.V.minmax.max)

    this.alloyForm.get('chemistry').get('Sn').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Sn.minmax.min)
    this.alloyForm.get('chemistry').get('Sn').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Sn.minmax.max)

    this.alloyForm.get('chemistry').get('Nb').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Nb.minmax.min)
    this.alloyForm.get('chemistry').get('Nb').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Nb.minmax.max)

    this.alloyForm.get('chemistry').get('B').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.B.minmax.min)
    this.alloyForm.get('chemistry').get('B').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.B.minmax.max)

    this.alloyForm.get('chemistry').get('W').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.W.minmax.min)
    this.alloyForm.get('chemistry').get('W').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.W.minmax.max)

    this.alloyForm.get('chemistry').get('Zn').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Zn.minmax.min)
    this.alloyForm.get('chemistry').get('Zn').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Zn.minmax.max)

    this.alloyForm.get('chemistry').get('Pb').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Pb.minmax.min)
    this.alloyForm.get('chemistry').get('Pb').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Pb.minmax.max)

    this.alloyForm.get('chemistry').get('Ti').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Ti.minmax.min)
    this.alloyForm.get('chemistry').get('Ti').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Ti.minmax.max)

    this.alloyForm.get('chemistry').get('Sr').get('minmax').get('min').setValue(this.copiedAlloy.chemistry.Sr.minmax.min)
    this.alloyForm.get('chemistry').get('Sr').get('minmax').get('max').setValue(this.copiedAlloy.chemistry.Sr.minmax.max)
  }

  onChanges(){

   
      var localSum;
    this.alloyForm.get('chemistry').valueChanges.subscribe(
      val => {
        // console.log('changed', val)
        localSum = val['C']['mean'] + val['Si']['mean'] + val['Mn']['mean'] + val['P']['mean'] + val['S']['mean'] + val['Cr']['mean'] + val['Cu']['mean'] + val['Mg']['mean'] + val['Ni']['mean'] + val['Mo']['mean'] + val['V']['mean'] + val['Sn']['mean'] + val['Nb']['mean'] + val['B']['mean'] + val['W']['mean'] + val['Zn']['mean'] + val['Pb']['mean'] + val['Ti']['mean'] + val['Sr']['mean']
        // console.log('sum is ', localSum);
        if(localSum<=100){
          this.alloyForm.get('chemistry').get('Fe').get('minmax').get('max').setValue(100-localSum, {emitEvent:false})
          this.alloyForm.get('chemistry').get('Fe').get('minmax').get('min').setValue(100-localSum, {emitEvent:false})
          this.alloyForm.get('chemistry').get('Fe').get('mean').setValue(100-localSum, {emitEvent:false})
        }
      }
    )
    this.alloyForm.get('chemistry').get('C').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
          //this.alloyForm.get('chemistry').get('C').get('minmax').get('max').setValue(val.min)  
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        
        this.alloyForm.get('chemistry').get('C').get('mean').setValue(num) 
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Si').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min 
         // this.alloyForm.get('chemistry').get('Si').get('minmax').get('max').setValue(val.min)

        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        let GELvalue = 1153+(6.7 * (this.alloyForm.get('chemistry').get('Si').get('mean').value));
        let WELvalue = 1147-(12 *  (this.alloyForm.get('chemistry').get('Si').get('mean').value));
        this.alloyForm.get('chemistry').get('Si').get('mean').setValue(num)
        this.alloyForm.get('calculatedValues').get('GEL').setValue(GELvalue.toString());
        this.alloyForm.get('calculatedValues').get('WEL').setValue(WELvalue.toString());
        ////console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Mn').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min 
        //  this.alloyForm.get('chemistry').get('Mn').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Mn').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('P').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
         // this.alloyForm.get('chemistry').get('P').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('P').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('S').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('S').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('S').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Cr').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Cr').get('minmax').get('max').setValue(val.min)
        }

        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Cr').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Cu').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
       //  this.alloyForm.get('chemistry').get('Cu').get('minmax').get('max').setValue(val.min)
        }

        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Cu').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Mg').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
         // this.alloyForm.get('chemistry').get('Mg').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Mg').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Ni').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
        //  this.alloyForm.get('chemistry').get('Ni').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Ni').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('Mo').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
         // this.alloyForm.get('chemistry').get('Mo').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Mo').get('mean').setValue(num)
        // console.log(val)
      }
    );

    this.alloyForm.get('chemistry').get('V').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
          this.alloyForm.get('chemistry').get('V').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('V').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Sn').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
         // this.alloyForm.get('chemistry').get('Sn').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Sn').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Nb').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
       //   this.alloyForm.get('chemistry').get('Nb').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Nb').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('B').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
      //    this.alloyForm.get('chemistry').get('B').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('B').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('W').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
       //   this.alloyForm.get('chemistry').get('W').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('W').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Zn').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
       //   this.alloyForm.get('chemistry').get('Zn').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Zn').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Pb').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
       //   this.alloyForm.get('chemistry').get('Pb').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Pb').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Ti').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
      //    this.alloyForm.get('chemistry').get('Ti').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Ti').get('mean').setValue(num)
        // console.log(val)
      }
    );


    this.alloyForm.get('chemistry').get('Sr').get('minmax').valueChanges.subscribe(
      val => {
        if(val.max < val.min){
          val.max = val.min
       //   this.alloyForm.get('chemistry').get('Sr').get('minmax').get('max').setValue(val.min)
        }
        let n = (val.min + val.max) /2;
        let num = parseFloat((n).toFixed(3))
        this.alloyForm.get('chemistry').get('Sr').get('mean').setValue(num)
        // console.log(val)
      }
    );

/*
//for calculating TL reference value (14/05)

this.alloyForm.get('chemistry').valueChanges.subscribe(
  val => {
    alert(this.alloyForm.get('chemistry').get('C').get('mean').value+" "+this.alloyForm.get('chemistry').get('Si').get('mean').value+" "+this.alloyForm.get('chemistry').get('P').get('mean').value)
    this.alloyForm.get('calculatedValues').get('TL_REF').setValue((14.45-this.alloyForm.get('chemistry').get('C').get('mean').value-0.25*this.alloyForm.get('chemistry').get('Si').get('mean').value-0.5*-this.alloyForm.get('chemistry').get('P').get('mean').value)/0.0089)
  });
*/
    
    // this.alloyForm.get('chemistry').get('Fe').get('minmax').valueChanges.subscribe(
    //   val => {
    //     if(val.max < val.min){
    //       val.max = val.min + 1
    //       this.alloyForm.get('chemistry').get('Fe').get('minmax').get('max').setValue(val.min+1)
    //     }
    //     this.alloyForm.get('chemistry').get('Fe').get('mean').setValue((val.min + val.max)/2)
    //     ////console.log(val)
    //   }
    // );

    this.alloyForm.get('grade').valueChanges.subscribe(
      val => {
        // console.log(val)
        if(val)
        {
          val = val.trim();
        this.alloyForm.get('calculatedValues').get('GRADE').setValue(val)
        }
      }
    );
    
    

   

    // this.alloyForm.get('calculatedValues').get('GEL').valueChanges.subscribe(
    //   val => {
    //     this.alloyForm.get('calculatedValues').get('GEL').setValue(val)
    //   }
    // );

    // this.alloyForm.get('calculatedValues').get('WEL').valueChanges.subscribe(
    //   val => {
    //     this.alloyForm.get('calculatedValues').get('WEL').setValue(val)
    //   }
    // );
  }

  resetForm(){
    this.alloyForm.reset();
  }

  
  getStandardAlloys(){
    this.alloyService.getStandardAlloys().subscribe(
      res => {
        this.alloys = res['standardAlloys'];
       //console.log('Got standard alloys', this.alloys)
        this.loading=false;
      },
      err=>{
       //console.log('Error getting standard alloys', err);
        this.serverErrorMessages = err.error.message
      }
    )
  }

  switchEdit(event){
   //console.log(event)
    this.editGELWEL = !this.editGELWEL
  }

}
